export enum ReferenceObjectType {
  User = 'User',
  Account = 'Account',
  Group = 'Group',
}
